import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AffiliateProgramCreativesEditModule } from '@modules/affiliate-program-creatives/submodules/edit/AffiliateProgramCreativesEditModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERSHIP_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATE_PROGRAM_CREATIVES_LIST_ROUTE_NAME,
  AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS,
  AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_CREATIVES,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliateProgramCreativesModule extends AppModule {
  protected submodules = [new AffiliateProgramCreativesEditModule()];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME,
      path: 'creatives',
      permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliateProgramCreativesListPage',
    });

    router.addChildRoute(AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_CREATIVES_LIST_ROUTE_NAME,
      path: ':type',
      permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateProgramCreativesListPage/AffiliateProgramCreativesListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERSHIP_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_PARTNERSHIP_CREATIVES'),
      to: {
        name: AFFILIATE_PROGRAM_CREATIVES_LIST_ROUTE_NAME,
        params: {
          type: 'link',
        },
      },
      permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      id: AFFILIATE_PROGRAM_CREATIVES_LIST_ROUTE_NAME,
      order: 60,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROGRAM_CREATIVES, getTranslationKeys);
  }
}
